var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2279_5691)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 56,
    height: 56,
    rx: 11.6667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 26C26 26.5523 25.5523 27 25 27C24.4477 27 24 26.5523 24 26C24 25.4477 24.4477 25 25 25C25.5523 25 26 25.4477 26 26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 26C29 26.5523 28.5523 27 28 27C27.4477 27 27 26.5523 27 26C27 25.4477 27.4477 25 28 25C28.5523 25 29 25.4477 29 26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 27C31.5523 27 32 26.5523 32 26C32 25.4477 31.5523 25 31 25C30.4477 25 30 25.4477 30 26C30 26.5523 30.4477 27 31 27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 23C21 22.4477 21.4477 22 22 22H40C40.5523 22 41 22.4477 41 23V26C41 26.5523 40.5523 27 40 27C39.4477 27 39 26.5523 39 26V24H23V36H29C29.5523 36 30 36.4477 30 37C30 37.5523 29.5523 38 29 38H22C21.4477 38 21 37.5523 21 37V23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 29C37.5523 29 38 29.4477 38 30C38 31.2668 38.2816 31.9508 38.6654 32.3346C39.0492 32.7184 39.7332 33 41 33C41.5523 33 42 33.4477 42 34C42 34.5523 41.5523 35 41 35C39.7332 35 39.0492 35.2816 38.6654 35.6654C38.2816 36.0492 38 36.7332 38 38C38 38.5523 37.5523 39 37 39C36.4477 39 36 38.5523 36 38C36 36.7332 35.7184 36.0492 35.3346 35.6654C34.9508 35.2816 34.2668 35 33 35C32.4477 35 32 34.5523 32 34C32 33.4477 32.4477 33 33 33C34.2668 33 34.9508 32.7184 35.3346 32.3346C35.7184 31.9508 36 31.2668 36 30C36 29.4477 36.4477 29 37 29Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2279_5691",
    x: 0.666667,
    y: 0.833333,
    width: 60.6667,
    height: 60.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.16667,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2279_5691"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2279_5691"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2279_5691",
    result: "effect2_dropShadow_2279_5691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2279_5691",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardThree);
export default __webpack_public_path__ + "static/media/card-three.18ab37f6dc184ce68caf5e7d1190910e.svg";
export { ForwardRef as ReactComponent };